export default __webpack_public_path__ + "static/media/cole-ribera-min.cd31d633.png";